module.exports = __webpack_public_path__ + "static/media/whyaudigo.37442d23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/whyaudigo.svg
// module id = 139
// module chunks = 0